// src/core/LoginScreen.js
import React, { useState } from 'react';
import { API_BASE_URL, toEnglishDigits } from './utils';

const LoginScreen = ({ onLoginSuccess, onNewUser }) => {
  const [nationalIdInput, setNationalIdInput] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleLogin = async () => {
    const englishNationalId = toEnglishDigits(nationalIdInput);

    if (!englishNationalId.trim() || !/^\d{10}$/.test(englishNationalId)) {
      setError('لطفاً کد ملی ۱۰ رقمی و معتبر را وارد کنید.');
      return;
    }
    setError('');
    setIsLoading(true);

    try {
      const response = await fetch(`${API_BASE_URL}/expert-info-exists/${englishNationalId}`);
      if (response.ok) {
        const data = await response.json();
        if (data.exists) {
          onLoginSuccess(englishNationalId);
        } else {
          onNewUser(englishNationalId);
        }
      } else {
        let errorDetails = `Status: ${response.status} ${response.statusText}`;
        let specificErrorMessage = 'خطا در بررسی کد ملی.';
        try {
          const errorData = await response.json();
          if (errorData.message && errorData.message.includes("Duplicate entry") && errorData.message.includes("for key 'national_id'")) {
            specificErrorMessage = "این کد ملی قبلاً ثبت شده است.";
          } else if (errorData.message) {
            specificErrorMessage = errorData.message;
          }
          errorDetails += `, Message: ${errorData.message || JSON.stringify(errorData)}`;
        } catch (jsonError) {
          const rawText = await response.text();
          errorDetails += `, Raw Response: ${rawText}`;
        }
        setError(specificErrorMessage);
        console.error("Error checking national ID:", errorDetails);
      }
    } catch (err) {
      setError('خطا در ارتباط با سرور. لطفاً اتصال اینترنت خود را بررسی کنید.');
      console.error("Network error during national ID check:", err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleLogin();
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center p-4" dir="rtl">
      <div className="bg-white p-8 rounded-lg shadow-xl max-w-md w-full text-center">
        <h2 className="text-2xl font-bold mb-4 text-blue-700">ورود به سیستم تحلیل پدیده‌ها</h2>
        <p className="mb-6 text-gray-700 leading-relaxed">
          برای شروع، لطفاً کد ملی خود را وارد کنید.
        </p>
        <div className="mb-4">
          <label htmlFor="nationalIdLogin" className="block text-sm font-medium text-gray-700 mb-1">کد ملی</label>
          <input
            type="text"
            id="nationalIdLogin"
            value={nationalIdInput}
            onChange={(e) => setNationalIdInput(e.target.value)}
            onKeyPress={handleKeyPress}
            className={`w-full p-3 border rounded-lg focus:ring-blue-500 focus:border-blue-500 text-center ${error ? 'border-red-500' : 'border-gray-300'}`}
            placeholder="کد ملی ۱۰ رقمی خود را وارد کنید"
            maxLength="10"
          />
          {error && <p className="text-red-500 text-xs mt-1">{error}</p>}
        </div>
        <button
          onClick={handleLogin}
          disabled={isLoading}
          className="bg-blue-700 hover:bg-blue-800 text-white font-semibold py-3 px-8 rounded-lg shadow-lg transition duration-300 ease-in-out transform hover:scale-105 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {isLoading ? 'در حال بررسی...' : 'ورود / ثبت‌نام'}
        </button>
      </div>
    </div>
  );
};

export default LoginScreen;
